var _rect, _rect2, _rect3, _rect4, _path, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDowntimeSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 14.5,
    width: 15,
    height: 5,
    fill: "#4092F5",
    stroke: "#4092F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 15,
    height: 5,
    fill: "#4092F5",
    stroke: "#4092F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 6,
    height: 6,
    fill: "#4092F5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 10,
    height: 6,
    fill: "#4092F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2915 8.46463L15.2892 8.46696L10.4839 13.1988L8.70845 11.4621C8.41492 11.1749 8.0287 10.9974 7.58716 10.9974C7.14562 10.9974 6.75939 11.1749 6.46586 11.4621L7.16514 12.1769L6.46586 11.4621C6.15319 11.7679 6 12.1649 6 12.5808C6 12.9966 6.15319 13.3936 6.46586 13.6995L6.46812 13.7017L9.37014 16.5226C9.67028 16.8355 10.0668 17 10.4954 17C10.9246 17 11.3217 16.835 11.622 16.5212L11.6809 16.4636L11.6809 16.4636L11.6832 16.4614L17.5341 10.702C17.5346 10.7016 17.535 10.7011 17.5355 10.7007C17.8473 10.395 18 9.9986 18 9.58333C18 9.16746 17.8468 8.77049 17.5341 8.46463C17.2406 8.1775 16.8544 8 16.4128 8C15.9713 8 15.5851 8.1775 15.2915 8.46463Z",
    fill: "white",
    stroke: "#4092F5",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 7,
    width: 14,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2915 8.46463L15.2892 8.46696L10.4839 13.1988L8.70845 11.4621C8.41492 11.1749 8.0287 10.9974 7.58716 10.9974C7.14562 10.9974 6.75939 11.1749 6.46586 11.4621L7.16514 12.1769L6.46586 11.4621C6.15319 11.7679 6 12.1649 6 12.5808C6 12.9966 6.15319 13.3936 6.46586 13.6995L6.46812 13.7017L9.37014 16.5226C9.67028 16.8355 10.0668 17 10.4954 17C10.9246 17 11.3217 16.835 11.622 16.5212L11.6809 16.4636L11.6809 16.4636L11.6832 16.4614L17.5341 10.702C17.5346 10.7016 17.535 10.7011 17.5355 10.7007C17.8473 10.395 18 9.9986 18 9.58333C18 9.16746 17.8468 8.77049 17.5341 8.46463C17.2406 8.1775 16.8544 8 16.4128 8C15.9713 8 15.5851 8.1775 15.2915 8.46463Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowntimeSelected);
export default __webpack_public_path__ + "static/media/downtime-selected.9bfce31cf43aa48456503399529f9a9e.svg";
export { ForwardRef as ReactComponent };